import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "all-page" }
const _hoisted_2 = { class: "tool-bar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"display":"flex","justify-content":"center","gap":"10px"} }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "description-cell" }
const _hoisted_9 = { style: {"color":"#868693"} }
const _hoisted_10 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        class: "add-btn",
        onClick: $setup.openAddDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AiPortalSetting.add")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: $setup.moduleDialogVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.moduleDialogVisible) = $event)),
      title: $setup.dialogTitle,
      width: "800",
      style: {"z-index":"99999"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.moduleDialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: $setup.handleModuleSubmit,
            class: "add-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('submit')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "moduleFormRef",
          model: $setup.moduleForm,
          rules: $setup.formRules,
          "label-width": "120px",
          style: {"padding":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('AiPortalSetting.logo')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "logo-uploader",
                  "show-file-list": false,
                  "on-success": $setup.handleLogoSuccess,
                  "before-upload": $setup.beforeLogoUpload,
                  action: $setup.uploadFileUrl,
                  data: $setup.LogoForm,
                  headers: { Authorization: `Bearer ` + $setup.getAccessToken() }
                }, {
                  default: _withCtx(() => [
                    ($setup.moduleForm.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.moduleForm.logo + '?' + $setup.getSasTokenFromCache(),
                          class: "logo-preview"
                        }, null, 8, _hoisted_3))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "logo-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["on-success", "before-upload", "action", "data", "headers"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('AiPortalSetting.name'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tabs, {
                  modelValue: $setup.activeTab,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.activeTab) = $event)),
                  type: "border-card",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tab_pane, {
                      label: "中文",
                      name: "zh"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "name.zh",
                          style: {"margin-bottom":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.moduleForm.name.zh,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.moduleForm.name.zh) = $event)),
                              placeholder: _ctx.$t('inputMsg')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "English",
                      name: "en"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "name.en",
                          style: {"margin-bottom":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.moduleForm.name.en,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.moduleForm.name.en) = $event)),
                              placeholder: _ctx.$t('inputMsg')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "日本語",
                      name: "jp"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "name.jp",
                          style: {"margin-bottom":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.moduleForm.name.jp,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.moduleForm.name.jp) = $event)),
                              placeholder: _ctx.$t('inputMsg')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('AiPortalSetting.description'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tabs, {
                  modelValue: $setup.activeDescTab,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.activeDescTab) = $event)),
                  type: "border-card",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tab_pane, {
                      label: "中文",
                      name: "zh"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "description.zh",
                          style: {"margin-bottom":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.moduleForm.description.zh,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.moduleForm.description.zh) = $event)),
                              type: "textarea",
                              rows: "3",
                              placeholder: _ctx.$t('inputMsg')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "English",
                      name: "en"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "description.en",
                          style: {"margin-bottom":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.moduleForm.description.en,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.moduleForm.description.en) = $event)),
                              type: "textarea",
                              rows: "3",
                              placeholder: _ctx.$t('inputMsg')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "日本語",
                      name: "jp"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "description.jp",
                          style: {"margin-bottom":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.moduleForm.description.jp,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.moduleForm.description.jp) = $event)),
                              type: "textarea",
                              rows: "3",
                              placeholder: _ctx.$t('inputMsg')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('AiPortalSetting.status')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: $setup.moduleForm.status,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.moduleForm.status) = $event)),
                  placeholder: _ctx.$t('selectMsg')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _ctx.$t('AiPortalSetting.online'),
                      value: 1
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.$t('AiPortalSetting.preparing'),
                      value: 2
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createElementVNode("section", _hoisted_5, [
      _createVNode(_component_el_table, {
        data: $setup.tableData,
        style: {"width":"100%","--el-color-primary":"#f36633"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('AiPortalSetting.logo'),
            width: "80"
          }, {
            default: _withCtx((scope) => [
              (scope.row.logo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: scope.row.logo + '?' + $setup.getSasTokenFromCache(),
                    class: "table-logo"
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('AiPortalSetting.name'),
            "min-width": "200"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString($setup.getCurrentName(scope.row)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('AiPortalSetting.description'),
            "min-width": "300"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_8, _toDisplayString($setup.getCurrentDescription(scope.row)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('AiPortalSetting.status'),
            width: "160"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                type: scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'info' : 'warning'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.status === 1 ? _ctx.$t('AiPortalSetting.online') : scope.row.status === 2 ? _ctx.$t('AiPortalSetting.preparing') : _ctx.$t('AiPortalSetting.comingSoon')), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('createTime'),
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_9, _toDisplayString($setup.formatTimestamp(scope.row.create_time)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('action'),
            width: "120"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                onClick: ($event: any) => ($setup.handleEdit(scope.row)),
                style: {"margin-right":"8px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Edit)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "danger",
                onClick: () => $setup.handleRowDelete(scope.row.id)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Delete)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("footer", _hoisted_10, [
      _createVNode(_component_el_pagination, {
        small: "",
        background: "",
        layout: "prev, pager, next, total",
        "current-page": $setup.currentPage,
        "page-size": $setup.pageNum,
        total: $setup.totalRecords,
        onCurrentChange: $setup.handleCurrentPageChange,
        style: {"--el-color-primary":"#f36633"}
      }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"]),
      _createVNode(_component_el_select, {
        class: "select-number",
        modelValue: $setup.pageNum,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.pageNum) = $event)),
        onChange: $setup.handlePageNumChange
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([10, 20, 30, 40, 50], (item) => {
            return _createVNode(_component_el_option, {
              key: item,
              label: item + '/page',
              value: item
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"])
    ])
  ]))
}